import { Col, ConfigProvider, Form, Input, Row } from "antd";
import cx from "classnames";

import { useTranslation } from "react-i18next";
import styles from "./Input.module.css";

const FormInput = ({
    label = "",
    name = "",
    placeholder = null,
    type = "text",
    size = "middle",
    onChange = () => { },
    className = "",
    subclassName = "",
    required = false,
    disabled = false,
    autoSize = false,
    rows = 8,
    autoComplete = "off",
    vertical = true,
    fontWeight = "",
    labelFontSize = "14px",
    suffixMessage = null,
    maxLength = null,
    suffix = null,
    width = "100%",
    formItemLayout = {},
    numberOnly = false,
    variant = "outlined", //["outlined", "borderless", "filled"]
    rules = null,
    defaultValue = null,
    allowClear = false,
    readOnly = false,
    textAlign = null
}) => {

    const handleChange = (e) => {
        // e.preventDefault();
        const value = e.target.value;
        onChange(value, e);
    };

    const { t, i18n } = useTranslation();

    const layout = {
        labelCol: {
            span: 24,
        },
        wrapperCol: {
            span: 24,
        }
    }
    return (
        <ConfigProvider theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },
            },
        }}>
            <Row direction="horizontal">
                <Col span={suffixMessage ? 5 : 24}>
                    <Form.Item shouldUpdate={() => false}>
                        {({ getFieldValue, setFieldValue }) =>
                            <Form.Item
                                {...(vertical && layout)}
                                labelAlign="left"
                                label={label}
                                name={name}
                                required={required}
                                style={{
                                    fontWeight: fontWeight,
                                    padding: "0px",
                                    margin: "0px"
                                }}
                                rules={rules ? [...rules, { required: required, message: i18n.language == 'th' ? 'กรุณากรอก ${label}' : '${label} is required' }] : [{ required: required, message: i18n.language == 'th' ? 'กรุณากรอก ${label}' : '${label} is required' }]}
                                {...formItemLayout}
                            >
                                {type === "text" || type === 'otp' ? (
                                    <Input
                                        style={{
                                            width,
                                            textAlign
                                        }}
                                        variant={variant}
                                        maxLength={maxLength}
                                        id={name}
                                        className={cx(styles.input, subclassName)}
                                        name={name}
                                        placeholder={placeholder ?? label}
                                        type={type}
                                        suffix={suffix}
                                        onFocus={(e) => {
                                            console.log("onFocus", e);
                                        }}
                                        onKeyDown={(e) => {
                                            if (numberOnly) {
                                                if (!e.key.match(/^[0-9]$/) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                    e.preventDefault();
                                                }
                                            }
                                        }}
                                        onChange={handleChange}
                                        disabled={disabled}
                                        size={size}
                                        autoComplete={autoComplete}
                                        allowClear={allowClear}
                                        readOnly={readOnly}
                                    />
                                ) : type === "password" ?
                                    <Input.Password
                                        id={name}
                                        className={cx(styles.input, subclassName)}
                                        name={name}
                                        placeholder={placeholder}
                                        onChange={handleChange}
                                        disabled={disabled}
                                        data-type={type}
                                        size={size}
                                        autoComplete={autoComplete}
                                    />
                                    : (
                                        <Input.TextArea
                                            rows={rows}
                                            autoSize={autoSize}
                                            id={name}
                                            className={cx(styles.input, subclassName)}
                                            name={name}
                                            placeholder={placeholder ?? label}
                                            type={type}
                                            onChange={handleChange}
                                            disabled={disabled}
                                            size={size}
                                            autoComplete={autoComplete}
                                            allowClear={allowClear}
                                        />
                                    )}
                            </Form.Item>
                        }
                    </Form.Item>
                    <Col flex={"auto"} style={{ alignContent: "center" }}>
                        {suffixMessage && (
                            <span>{suffixMessage}</span>
                        )}
                    </Col>
                </Col>

            </Row>

        </ConfigProvider >
    );
};

export default FormInput;
